// extracted by mini-css-extract-plugin
export default {"message":"styles_message__wPK5d","title":"styles_title__RamDe","subtitle":"styles_subtitle__nd7ya"};